module.exports = __webpack_public_path__ + "img/home-mediterranean-patio.e4eb71b9.jpg";